import { useState, type ReactNode } from "react";
import { SectionsContext } from "./Contexts";

export function Sections({ children }: { children: ReactNode }) {
    const [active, setActive] = useState<unknown | null>(null);

    return (
        <SectionsContext.Provider value={{ active, setActive }}>
            {children}
        </SectionsContext.Provider>
    );
}
